import React from 'react'
import { getSortedTimezones } from '../../utils/timezone'

/**
 * Coach Details Section Component
 * Displays coach information and timezone selector
 */
const CoachDetailsSection = ({
  coachName,
  duration,
  totalSessions,
  clientTimezone,
  onTimezoneChange,
  firstSlotDuration,
  otherSlotsDuration,
  hasGrowthInRemaining,
  schedulingType,
  sowType,
}) => {
  const renderDurationSection = () => {
    const isQuestSow = sowType === 'QUEST'

    // For QUEST type SOWs, show both growth and regular session durations if available
    if (isQuestSow) {
      if (firstSlotDuration && otherSlotsDuration) {
        return (
          <>
            Growth Session: {firstSlotDuration} Minutes
            <br />
            Wisdom Session: {otherSlotsDuration} Minutes
          </>
        )
      }
      // Fallback to generic duration
      return `${duration || otherSlotsDuration} Minutes`
    }

    // First-session flow schedules only one session: growth if present, else coaching
    if (schedulingType === 'first-session') {
      if (hasGrowthInRemaining && firstSlotDuration) {
        return `Growth Session: ${firstSlotDuration} Minutes`
      }
      if (otherSlotsDuration) {
        return `Coaching Session: ${otherSlotsDuration} Minutes`
      }
    }

    // Other flows: if growth is still remaining show both, otherwise coaching only
    if (hasGrowthInRemaining && firstSlotDuration && otherSlotsDuration) {
      return (
        <>
          Growth Session: {firstSlotDuration} Minutes
          <br />
          Coaching Session: {otherSlotsDuration} Minutes
        </>
      )
    }

    // If hasGrowthInRemaining is false, show only coaching/regular session duration
    if (otherSlotsDuration) {
      return `Coaching Session: ${otherSlotsDuration} Minutes`
    }

    // Fallback: show generic duration
    return `${duration} Minutes`
  }

  return (
    <div className='first-session-schedule__coach-details pt-32px'>
      <div className='first-session-schedule__detail-item'>
        <div className='s10c'>COACH NAME</div>
        <div className='s8 mt-2'>{coachName}</div>
      </div>
      <div className='first-session-schedule__detail-item'>
        <div className='s10c'>DURATION</div>
        <div className='s8 mt-2'>{renderDurationSection()}</div>
      </div>
      {sowType !== 'QUEST' && (
        <div className='first-session-schedule__detail-item'>
          <div className='s10c'>NO. OF SESSIONS</div>
          <div className='s8 mt-2'>{totalSessions}</div>
        </div>
      )}
      <div className='first-session-schedule__detail-item'>
        <div className='s10c'>TIMEZONE</div>
        <div className='first-session-schedule__timezone-select-wrapper'>
          <select
            className='form-select s8 mt-2 first-session-schedule__timezone-select custom-timezone-select'
            value={clientTimezone}
            onChange={onTimezoneChange}>
            {getSortedTimezones().map((tz) => (
              <option key={tz.value} value={tz.value}>
                {tz.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  )
}

export default CoachDetailsSection
